import React, { useState } from 'react';
import FeedbackModal from '../Common/FeedbackModal';

// Static links — terms / privacy / etc.  Feedback is rendered separately because
// it opens a modal instead of navigating.
const LINKS = [
  { label: 'Terms of Service',     url: 'https://deliverhealthcommunityportal.durablesites.com/terms-of-service' },
  { label: 'Privacy Policy',       url: 'https://deliverhealthcommunityportal.durablesites.com/privacy-policy' },
  { label: 'Compliance',           url: 'https://deliverhealthcommunityportal.durablesites.com/compliance' },
  { label: 'ai.deliverhealth.com', url: 'https://ai.deliverhealth.com' },
];

const s = {
  footer: {
    background: 'linear-gradient(180deg, #0a1f33 0%, #061829 100%)',
    borderTop: '1px solid rgba(29,156,156,0.18)',
    padding: '22px 24px',
    marginTop: 'auto',
  },
  inner: {
    maxWidth: '1280px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  pill: (isHover) => ({
    padding: '8px 22px',
    borderRadius: '999px',
    background: isHover
      ? 'linear-gradient(135deg, #1d9c9c 0%, #0d7377 100%)'
      : 'rgba(255, 255, 255, 0.06)',
    border: '1px solid ' + (isHover ? 'transparent' : 'rgba(29,156,156,0.35)'),
    color: isHover ? '#ffffff' : '#a9d8d8',
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '0.01em',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: isHover
      ? '0 6px 18px rgba(13,115,119,0.35), 0 1px 2px rgba(0,0,0,0.15)'
      : '0 1px 2px rgba(0,0,0,0.2)',
    userSelect: 'none',
    display: 'inline-block',
  }),
  // Slightly more prominent treatment for the Feedback CTA to draw the eye.
  feedbackPill: (isHover) => ({
    padding: '8px 22px',
    borderRadius: '999px',
    background: isHover
      ? 'linear-gradient(135deg, #4fd1c5 0%, #1d9c9c 100%)'
      : 'linear-gradient(135deg, #1d9c9c 0%, #0d7377 100%)',
    border: '1px solid rgba(255,255,255,0.18)',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.01em',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: isHover
      ? '0 8px 22px rgba(79,209,197,0.40), 0 1px 2px rgba(0,0,0,0.15)'
      : '0 6px 16px rgba(13,115,119,0.35), 0 1px 2px rgba(0,0,0,0.15)',
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontFamily: 'inherit',
  }),
};

export default function Footer() {
  const [hover, setHover] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  return (
    <>
      <footer style={s.footer}>
        <div style={s.inner}>
          {LINKS.map((link) => (
            <a
              key={link.label}
              href={link.url}
              target={link.url.startsWith('http') ? '_blank' : undefined}
              rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
              style={s.pill(hover === link.label)}
              onMouseEnter={() => setHover(link.label)}
              onMouseLeave={() => setHover(null)}
            >
              {link.label}
            </a>
          ))}

          <button
            type="button"
            onClick={() => setShowFeedback(true)}
            onMouseEnter={() => setHover('feedback')}
            onMouseLeave={() => setHover(null)}
            style={s.feedbackPill(hover === 'feedback')}
            title="Share feedback about DASH"
          >
            <img
              src="/comment.png"
              alt=""
              aria-hidden="true"
              style={{
                width: 16, height: 16,
                display: 'block', flexShrink: 0,
                /* white-ish render on the teal pill — invert + brighten so
                   most icon colorings come through as white-on-teal */
                filter: 'brightness(0) invert(1)',
              }}
            />
            Feedback
          </button>
        </div>
      </footer>

      {showFeedback && (
        <FeedbackModal
          queryId={null}
          title="Share your feedback"
          subtitle="Tell us anything — bugs, missing answers, ideas. Contact info is optional."
          onClose={() => setShowFeedback(false)}
        />
      )}
    </>
  );
}
